<div style="display: flex">
    <p-dialog header="Are you sure?" [(visible)]="showDeleteDialog"
        [maximizable]="false" [closable]="false" [closeOnEscape]="false">
        <h3>
            {{this.areYouSureDeleteDesc}}
        </h3>
        <ng-template #footer>
            <button type="button" pButton icon="pi pi-check"
                (click)="confirmDelete()" label="Confirm" class="p-button-text p-button-success"></button>
            <button type="button" pButton (click)="this.showDeleteDialog = false"
                icon="pi pi-times" label="Cancel" class="p-button-text p-button-danger"></button>
        </ng-template>
    </p-dialog>
</div>
<div style="display: flex;">
    <p-dialog header="Add Policy/Criteria" [(visible)]="this.showDialog" [maximizable]="false" [closable]="false"
        [closeOnEscape]="false" [style]="{ 'min-width': '25vw' }">
        <form [formGroup]="addFormGroup" #addForm="ngForm" id="addForm">

            <div class="flex items-center justify-content-center">
                <div class="p-field-radiobutton mr-2 mb-4">
                    <p-radioButton name="selectpolicy" value="selectpolicy" formControlName="selectpolicy" inputId="selectpolicy"></p-radioButton>
                    <label class='radio-label ml-2' for="selectpolicy">Select Policy</label>
                </div>
                <div class="p-field-radiobutton">
                    <p-radioButton name="addpolicy" value="addpolicy" formControlName="addpolicy" inputId="addpolicy"></p-radioButton>
                    <label class='radio-label ml-2' for="addpolicy">Add Policy</label>
                </div>
            </div>

            <div *ngIf="this.groupsSelectItem && this.addFormGroup.controls['selectpolicy'].value != null">
                <p-floatLabel variant="on" class="mb-4">
                    <p-select [options]="groupsSelectItem" [filter]="false" appendTo="body" [autoDisplayFirst]="false"
                        formControlName="policyGroup"
                        styleClass="w-full">
                    </p-select>
                    <label for="float-dd" [ngClass]="{ 'invalid': policyGroupInvalid }">{{this.policyGroupPlaceholder}}</label>
                    <small *ngIf="this.policyGroupInvalid" class="p-invalid">Policy is required.</small>
                </p-floatLabel>
            </div>

            <div>
                <p-floatLabel variant="on" class="mb-4" *ngIf="this.showGroupNameInput && this.addFormGroup.controls['addpolicy'].value != null">
                    <input [ngClass]="{ 'p-invalid': addGroupInvalid }" type="text" pInputText
                        formControlName="groupName" class="w-full"/>
                    <label for="float-dd">Policy Name</label>
                </p-floatLabel>
                <small *ngIf="this.addGroupInvalid" class="p-invalid">Policy name required.</small>
            </div>

            <div style="border-bottom: 2px solid lightgrey; width: 100%;" class="mb-4">
                <label style="padding-left: 1em; margin-top: 2em; font-weight: 500;">Policy Criteria</label>
            </div>

            <p-floatLabel variant="on" class="mb-4">
                <input [ngClass]="{ 'p-invalid': this.yearsOfServiceStartInvalid }" type="text" pInputText formControlName="yearsOfServiceStart" style="width: 100%;" />
                <label for="float-dd" [ngClass]="{ 'invalid': yearsOfServiceStartInvalid }">Years of Service Start</label>
                <small *ngIf="this.yearsOfServiceStartInvalid" class="p-invalid">Years of Service Start is required.</small>
            </p-floatLabel>

            <p-floatLabel variant="on" class="mb-4">
                <input [ngClass]="{ 'p-invalid': this.yearsOfServiceEndInvalid }" type="text" pInputText formControlName="yearsOfServiceEnd" style="width: 100%;" />
                <label for="float-dd" [ngClass]="{ 'invalid': yearsOfServiceEndInvalid }">Years of Service End</label>
                <small *ngIf="this.yearsOfServiceEndInvalid" class="p-invalid">Years of Service End is required.</small>
            </p-floatLabel>

            <div *ngIf="this.accrualPeriodsSelectItem">
                <p-floatLabel variant="on" class="mb-4">
                    <p-select [options]="accrualPeriodsSelectItem" [filter]="false" appendTo="body" [autoDisplayFirst]="false"
                            formControlName="accrualPeriod" styleClass="w-full">
                    </p-select>
                    <label for="float-dd" [ngClass]="{ 'invalid': accrualPeriodInvalid }">Accrual Period</label>
                    <small *ngIf="this.accrualPeriodInvalid" class="p-invalid">Accrual Period is required.</small>
                </p-floatLabel>
            </div>

            <p-floatLabel variant="on" class="mb-4">
                <input [ngClass]="{ 'p-invalid': this.hoursAccruedInvalid }" type="text" pInputText formControlName="hoursAccrued" style="width: 100%;" />
                <label for="float-dd" [ngClass]="{ 'invalid': hoursAccruedInvalid }">Hours Accrued</label>
                <small *ngIf="this.hoursAccruedInvalid" class="p-invalid">Hours Accrued is required.</small>
            </p-floatLabel>

            <p-floatLabel variant="on">
                <input [ngClass]="{ 'p-invalid': this.vacAccrualMaxInvalid }" type="text" pInputText formControlName="vacationaccrualmax" style="width: 100%;" />
                <label for="float-dd" [ngClass]="{ 'invalid': vacAccrualMaxInvalid }">Vacation Accrual Max</label>
                <small *ngIf="this.vacAccrualMaxInvalid" class="p-invalid">Vacation Accrual Max is required.</small>
            </p-floatLabel>
        </form>

        <ng-template #footer>
            <button type="button" pButton icon="pi pi-check"
                class="p-button-text p-button-success" label="Confirm" (click)="addPolicy()"></button>
            <button type="button" pButton icon="pi pi-times"
                class="p-button-text p-button-danger" label="Cancel" (click)="closeDialog()"></button>
        </ng-template>
    </p-dialog>
</div>

<p-toolbar>
    <button type="button" pButton pRipple class="p-button-secondary" label="Add Policy/Criteria" (click)="addPolicyClicked()"></button>
</p-toolbar>

<p-table stripedRows #SetupTable [scrollable]="true" [style]="{ 'max-width': '100%' }" scrollHeight="flex"
    [value]="policySetup" editMode="row" (onEditInit)="onEditInit($event)"
    (onRowEditSave)="onRowEditSave($event)" dataKey="Policyid">
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="17" style="text-align: center">
                <div class="tabulator-placeholder">
                    <span> No Data Available </span>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template #header>
        <tr>
            <th class="edit-cell"></th>
            <th class="status-cell">
                <i class="pi pi-exclamation-circle" title="Status"></i>
            </th>
            <th pSortableColumn="PolicyTitle">
                Policy
                <p-sortIcon field="PolicyTitle" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order">
                </p-sortIcon>
                <p-columnFilter field="PolicyTitle" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                    [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect
                            class="filter"
                            defaultLabel="Filter"
                            [options]="policyFilterSelectItem"
                            [filter]="false"
                            appendTo="body"
                            styleClass="w-full"
                            [ngModel]="value"
                            (ngModelChange)="filter($event)"
                        >
                        </p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <th pSortableColumn="YearsOfServiceStart">
                Employee Service Yrs Start
                <p-sortIcon field="YearsOfServiceStart" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order">
                </p-sortIcon>
            </th>
            <th pSortableColumn="YearsOfServiceCeiling">
                Employee Service Yrs End
                <p-sortIcon field="YearsOfServiceCeiling" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order">
                </p-sortIcon>
            </th>
            <th pSortableColumn="AccrualPeriod">
                Accrual Period
                <p-sortIcon field="AccrualPeriod" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order">
                </p-sortIcon>
                <p-columnFilter field="AccrueLeavePeriodID" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                    [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect
                            class="filter"
                            defaultLabel="Filter"
                            [options]="accrualPeriodsSelectItem"
                            [filter]="false"
                            appendTo="body"
                            styleClass="w-full"
                            [ngModel]="value"
                            (ngModelChange)="filter($event)"
                        >
                        </p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <th pSortableColumn="HoursAccrued">
                Hours Accrued
                <p-sortIcon field="HoursAccrued" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order">
                </p-sortIcon>
            </th>
            <th pSortableColumn="vacationaccrualmax">
                Vacation Accrual Max
                <p-sortIcon field="vacationaccrualmax " ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order">
                </p-sortIcon>
            </th>
            <th class="delete-cell"></th>
        </tr>
    </ng-template>
    <ng-template #body let-setup let-edit="editing" let-ri="rowIndex">
        <tr [pEditableRow]="setup" data-id="row-{{ setup.Policyid }}">
            <td class="edit-cell">
                <button *ngIf="
                        !edit &&
                        (!editing?.Policyid ||
                            !editing?.Policyid ===
                                setup?.Policyid)
                    " pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                    (click)="onRowEditInit(setup)" class="p-button-rounded p-button-text"
                     title="Edit"></button>
                <button *ngIf="edit" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                    (click)="onRowEditSave(setup)" class="
                        p-button-rounded
                        p-button-text
                        p-button-success
                    " ></button>
                <button *ngIf="edit" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                    (click)="onRowEditCancel(setup)" class="
                        p-button-rounded
                        p-button-text
                        p-button-danger
                    "></button>
            </td>
            <td class="status-cell">
                <a (click)="onStatusClick(setup)">
                    <div>
                        <ef-status-icon [status]="
                                setup?.Status?.StatusCode
                            " [message]="
                                setup?.Status?.Message
                            "></ef-status-icon>
                    </div>
                </a>
            </td>
            <td>
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <input pInputText type="text" [(ngModel)]="setup.PolicyTitle" />
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ setup.PolicyTitle }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <td>
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <input pInputText type="text" [(ngModel)]="setup.YearsOfServiceStart" />
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ setup.YearsOfServiceStart }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <td>
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <input pInputText type="text" [(ngModel)]="setup.YearsOfServiceCeiling" />
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ setup.YearsOfServiceCeiling }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <td>
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <div *ngIf="this.accrualPeriodsSelectItem as items">
                            <ef-dropdown [items]="items" [rowData]="setup" property="AccrualPeriodID"></ef-dropdown>
                            <!-- <p-dropdown [options]="items" [filter]="false" appendTo="body"
                                [autoDisplayFirst]="false" [(ngModel)]="setup.AccrualPeriodID">
                            </p-dropdown> -->
                        </div>
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ findAccrualPeriod(setup) }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <td>
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <input pInputText type="text" [(ngModel)]="setup.HoursAccrued" />
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ setup.HoursAccrued }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <td>
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <input pInputText type="text" [(ngModel)]="setup.vacationaccrualmax" />
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ setup.vacationaccrualmax }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <td class="delete-cell">
                <button pButton type="button" class="p-button-danger p-button-text" icon="pi pi-trash" (click)="deleteClicked(setup)"></button>
            </td>
        </tr>
    </ng-template>
</p-table>
